import { ProcedureDetailsCard } from './procedures-details-card';
import { trpc } from '@web/lib/trpc';

type ProcedureDetailsViewProps = {
  procedureId: string;
  onClose?: () => void;
};

export function ProcedureDetailsView({
  procedureId,
  onClose,
}: ProcedureDetailsViewProps) {
  const { data: procedureDetailsData, refetch: refetchProceduresData } =
    trpc.procedure.getDetails.useQuery({
      id: procedureId,
    });

  const { mutateAsync: updateProcedureMutation } =
    trpc.procedure.edit.useMutation();

  const { data: categories } = trpc.procedure.listAllCategories.useQuery();

  if (!procedureDetailsData || !categories) return null;

  return (
    <ProcedureDetailsCard
      procedure={procedureDetailsData}
      categoryList={categories}
      onClose={() => {
        void refetchProceduresData();

        onClose?.();
      }}
      onSubmit={async (data) => {
        await updateProcedureMutation(data);
      }}
    />
  );
}
